// Classic: today's public site (ARCHITECTURE §6). Eager (D10): `module`, not
// `load`. No options: frozen for parity and always follows the full league
// palette. legacyExemptions: known gaps kept for pixel parity, each tied to
// an issue (§6.5). Fixing one removes its entry and updates the classic baseline.

import { defineManifest } from '../../core/template/defineTemplate'
import { SITE_TEMPLATE_CONTRACT } from '../../core/template/types'
import classicTemplate from './template'
import thumbnail from './thumbnail.webp'

export default defineManifest({
  id: 'classic',
  name: 'Classic',
  // Picker text: the admin catalogue (siteTemplates.classic), in the admin's language (#1063).
  description: (m) => m.siteTemplates.classic.description,
  bestFor: (m) => m.siteTemplates.classic.bestFor,
  status: 'stable',
  contract: SITE_TEMPLATE_CONTRACT,
  // The fictional Ironbridge league (no real tenant in picker thumbnails).
  thumbnail,
  options: [],
  capabilities: { homeColumns: true, homeMobileOrder: true },
  // Classic keeps today's lifetime stats scope (parity); new templates
  // default to the league's public season. #583: Classic Home has no division
  // switcher, so it always shows All divisions (a pick made on Schedule
  // mustn't silently narrow it). Without 2+ live divisions nothing changes.
  pageDefaults: { statsScope: 'lifetime', homeDivision: 'all' },
  legacyExemptions: [
    // Footer gaps (schedule, game, page, live; player/team/sponsor non-ready)
    // and the chrome-free form are encoded in classic's chrome matrix.
    { rule: 'not-found', issue: '#312' },
  ],
  module: classicTemplate,
})
